




import { Component, Vue } from "vue-property-decorator";

@Component({
	name: "main-footer",
})
export default class MainFooter extends Vue {
}
